import apiOrp from "../../../../Shared/interceptor/apiOrp";
import {
  LINE_TYPE_URL,
  FETCH_CONFIGURATION,
  GET_OTP_URL,
  RESEND_OTP_URL,
  VERIFY_OTP_URL,
  FETCH_BILL_URL,
  VALIDATE_MSIDN_ACCOUNT_URL,
  GET_INVOICE_DETAIL,
  GET_BUNDLE_URL,
  GET_OTP_V1,
  VERIFY_OTP_V1,
  GET_QUERY_BALANCE,
  CHECK_AM_STATUS,
  RESEND_OTP_V1,
  FETCH_PAYMENT_STATUS,
  EXCHANGE_RATES,
  LEAD_SUBMIT,
  VERIFY_OTP_AND_AM_USER,
  LEAD_STATUS,
  SAVE_FORM,
  SEND_HBB_OTP
} from "../../helper/constants";


export function getLineType(requestdata) {
  return apiOrp.post(LINE_TYPE_URL, requestdata)
}
export function getBundles(req) {
  return apiOrp.post(GET_BUNDLE_URL, req.data)
}
export function fetchConfiguration() {
  return apiOrp.get(FETCH_CONFIGURATION)
}

export function getOtp(req) {
  return apiOrp.post(GET_OTP_URL, req.data)
}

export function getInvoice(req) {
  return apiOrp.post(GET_INVOICE_DETAIL, req)
}

export function resendOtp(req) {
  return apiOrp.post(RESEND_OTP_URL, req.data);
}

export function verifyOtp(req) {
  return apiOrp.post(VERIFY_OTP_URL, req.data);
}

export function validateMsidnViaAccount(req) {
  return apiOrp.post(VALIDATE_MSIDN_ACCOUNT_URL, req.data)
}

export function getBillAmount(req) {
  return apiOrp.post(FETCH_BILL_URL, req.data)
}

export function getPaymentOptions(req) {
  return apiOrp.post(req.url, req.data)
}

export function intiatePayment(req) {
  return apiOrp.post(req.url, req.data, { headers: req.headers })
}

export function processTrans(req) {
  return apiOrp.post(req.url, req.data, { headers: req.headers })
}

export function getOtpV1(req) {
  return apiOrp.post(GET_OTP_V1, req.data)
}

export function verifyOtpV1(req) {
  return apiOrp.post(VERIFY_OTP_V1, req.data)
}

export function getQueryBalance(req) {
  return apiOrp.post(GET_QUERY_BALANCE, req.data)
}

export function checkAMstatus(txnId) {
  return apiOrp.get(CHECK_AM_STATUS + txnId)
}

export function resendOtpV1(req) {
  return apiOrp.post(RESEND_OTP_V1, req.data)
}

export function getPaymentStatus(txnId, modeDetails) {
  let url = FETCH_PAYMENT_STATUS + txnId;
  if (modeDetails?.channel && modeDetails?.paymentMode) {
    url = url + `&channel=${modeDetails.channel}&pg=${modeDetails.paymentMode}`
  }
  return apiOrp.get(url)
}

export function getExchangeRates(req) {
  return apiOrp.post(EXCHANGE_RATES, req.data)
}


export function submitLead(req) {
  return apiOrp.post(LEAD_SUBMIT, req)
}

export function verifyOtpAndAmUser(req) {
  return apiOrp.post(VERIFY_OTP_AND_AM_USER, req?.data);
}

export function getLeadStatus(req) {
  return apiOrp.post(LEAD_STATUS, req.data)
}

export function getHbbAccoundDetails(req) {
  return apiOrp.post(SEND_HBB_OTP, req.data)
}

export function submitBusinessContactForm(req) {
  return apiOrp.post(SAVE_FORM, req)
}


